import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Warning Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "M249.855 199.777 151.916 29.69c-10.717-18.248-37.103-18.248-47.821 0L6.155 199.777a26.33 26.33 0 0 0 0 26.565 27.27 27.27 0 0 0 23.912 13.652h195.878a27.27 27.27 0 0 0 23.888-13.652 26.33 26.33 0 0 0 .022-26.565m-15.533 17.594a9.52 9.52 0 0 1-8.377 4.704H30.067a9.52 9.52 0 0 1-8.378-4.704 8.5 8.5 0 0 1 0-8.646L119.63 38.64c3.807-6.336 12.991-6.336 16.799 0l97.939 170.086a8.5 8.5 0 0 1-.045 8.646M119.046 150.4V105.6c0-6.897 7.466-11.208 13.44-7.76a8.96 8.96 0 0 1 4.48 7.76v44.798c0 6.897-7.467 11.207-13.44 7.759a8.96 8.96 0 0 1-4.48-7.76m22.399 40.317c0 10.346-11.2 16.812-20.16 11.64-8.959-5.174-8.959-18.106 0-23.278 2.044-1.18 4.361-1.801 6.72-1.8 7.423 0 13.44 6.016 13.44 13.438" }, null, -1)
  ])))
}
export default { render: render }